export default __webpack_public_path__ + "static/media/akc-card-logo.b93043b5.svg";